import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return [
      "groupCheckbox",
      "groupDismissSuccess",
      "groupReinstatementSuccess",
      "groupError",
      "groupErrorMessage",
      "promptError",
      "promptErrorMessage"
    ]
  }

  static get values() {
    return {
      groupKey: String,
      promptKey: String,
      userId: Number,
      dismissed: { type: Boolean, default: false }
    }
  }

  connect() {
    this.syncGroupCheckbox()
    this.clearGroupMessages()
    this.hidePromptError()
  }

  async dismissPrompt(event) {
    event.preventDefault()
    this.hidePromptError()

    try {
      await this.request("POST", this.promptKeyValue)
      this.element.style.display = "none"
    } catch (error) {
      this.promptErrorMessageTarget.textContent = error.message
      this.promptErrorTarget.hidden = false
    }
  }

  async toggleGroupDismissal(event) {
    event.preventDefault()
    this.clearGroupMessages()

    try {
      if (this.dismissedValue) {
        await this.request("DELETE", this.groupKeyValue)
        this.dismissedValue = false
        this.groupReinstatementSuccessTarget.hidden = false
      } else {
        await this.request("POST", this.groupKeyValue)
        this.dismissedValue = true
        this.groupDismissSuccessTarget.hidden = false
      }
    } catch (error) {
      this.groupErrorMessageTarget.textContent = error.message
      this.groupErrorTarget.hidden = false
    }

    this.syncGroupCheckbox()
  }

  async request(method, key) {
    const response = await fetch("/api/v1/user-prompt-activities", {
      method,
      headers: {
        "Content-Type": "application/vnd.api+json",
        "X-CSRF-Token": this.csrfToken
      },
      body: JSON.stringify({
        data: {
          attributes: {
            user_id: this.userIdValue,
            key,
            name: "dismissal"
          }
        }
      })
    })

    if (!response.ok) {
      throw new Error(response.statusText || `Request failed with status ${response.status}`)
    }
  }

  clearGroupMessages() {
    if (!this.hasGroupCheckboxTarget) { return }

    this.groupDismissSuccessTarget.hidden = true
    this.groupReinstatementSuccessTarget.hidden = true
    this.groupErrorTarget.hidden = true
    this.groupErrorMessageTarget.textContent = ""
  }

  hidePromptError() {
    this.promptErrorTarget.hidden = true
    this.promptErrorMessageTarget.textContent = ""
  }

  syncGroupCheckbox() {
    if (!this.hasGroupCheckboxTarget) { return }

    this.groupCheckboxTarget.checked = this.dismissedValue
  }

  get csrfToken() {
    const csrfMetaTag = document.querySelector("meta[name='csrf-token']")

    return csrfMetaTag ? csrfMetaTag.content : ""
  }
}
